module.exports = __webpack_public_path__ + "static/media/illustration.67c9d836.svg";